// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';

import Button from '@shared/components/Button';
import ParkIcon from '@shared/icons/Park';
import ParkingIcon from '@shared/icons/Parking';
import ROUTES from '@shared/constants/routes';

export interface NoMatchProps {
  className?: string;
  forbidden?: boolean;
}

const NoMatch: React.FC<NoMatchProps> = (props) => {
  const classes = withStyles.getClasses(props);
  const { forbidden } = props;
  const message = forbidden
    ? 'You do not have permission to access the requested page'
    : 'The page you were looking for doesn’t exist';
  const errorCode = forbidden ? 403 : 404;
  const Icon = forbidden ? ParkingIcon : ParkIcon;

  return (
    <Grid
      container
      direction="column"
      className={classes.root}
      justifyContent="center"
      alignItems="center"
    >
      <Icon className={classes.icon} />
      <h6 className={classes.message}>{message}</h6>
      <span className={classes.errorCode}>Error code: {errorCode}</span>
      <Button
        text="Go to home page"
        component={Link}
        componentProps={{ to: ROUTES.initial }}
      />
    </Grid>
  );
};

const NoMatchStyled = withStyles(
  NoMatch, 
  (theme, props) => ({
    "root": {
      height: '80vh',
    },
    "icon": {
      fontSize: 64,
    },
    "message": {
      fontSize: 24,
      margin: theme.spacing(4, 0, 0),
      color: theme.palette.colors.greyDark,
    },
    "errorCode": {
      fontSize: 13,
      color: theme.palette.colors.greyLight3,
      marginBottom: theme.spacing(8),
    }
  })
);

export default NoMatchStyled;